import { observer } from 'mobx-react';
import { IBenefitsRewardsMobileItem } from '~views/marketing-page/benefits-rewards/IBenefitsRewards';
import * as React from 'react';
import { classes } from '~utils/Classes';
import styled from 'styled-components';
import { LoyaltyTierDiamond } from '~views/LoyaltyTierDiamond';

const BENEFTIS_REWARDS_ITEM_TEST_ID = 'benefits-rewards-item';

const benefitsRewardsListItemWrapperClass = classes(
    'loyalty-marketing-page-benefits-rewards__listItemWrapper'
);
const benefitsRewardsLiClass = classes('loyalty-marketing-page-benefits-rewards__list__item');
const benefitsRewardsLiContent = classes(
    'loyalty-marketing-page-benefits-rewards__list__item__content'
);
const benefitsRewardsTableTableHeading3Class = classes(
    'loyalty-marketing-page-benefits-rewards__tableHeading3'
);
const benefitsRewardsTableTableHeading4Class = classes(
    'loyalty-marketing-page-benefits-rewards__tableHeading4'
);

const BenefitsRewardsListItemWrapper = styled.div`
    grid-area: MarketingPageBenefitsRewardsListItem;
`;

const BenefitsRewardsTableHeading3 = styled.p<{ textColor: string }>`
    color: ${({ textColor }) => `#${textColor}`};
    grid-area: benefitsRewardsTableHeading3;
`;

const BenefitsRewardsTableHeading4 = styled.p<{ textColor: string }>`
    color: ${({ textColor }) => `#${textColor}`};
    grid-area: benefitsRewardsTableHeading4;
`;

export const BenefitsRewardsItem = observer(function EarnPointsDetails({
    heading,
    subHeading,
    sign,
    tierColor,
    textColor,
    tier
}: IBenefitsRewardsMobileItem) {
    return (
        <li className={benefitsRewardsLiClass} data-test-id={BENEFTIS_REWARDS_ITEM_TEST_ID}>
            <BenefitsRewardsListItemWrapper className={benefitsRewardsListItemWrapperClass}>
                <LoyaltyTierDiamond loyaltyTier={tier || 0} textColor={tierColor.hex} sign={sign} />
                <div className={benefitsRewardsLiContent}>
                    <BenefitsRewardsTableHeading3
                        textColor={textColor.hex}
                        className={benefitsRewardsTableTableHeading3Class}
                    >
                        {heading}
                    </BenefitsRewardsTableHeading3>
                    {subHeading.length > 0 && (
                        <BenefitsRewardsTableHeading4
                            textColor={textColor.hex}
                            className={benefitsRewardsTableTableHeading4Class}
                        >
                            {subHeading}
                        </BenefitsRewardsTableHeading4>
                    )}
                </div>
            </BenefitsRewardsListItemWrapper>
        </li>
    );
});
